import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Container,
  Row,
  Col,
  Button,
  Media,
  Label
} from 'reactstrap';
import Fade from 'react-reveal/Fade';
import ProcessSvg from './img/Process.svg';
import ConcreteSectionStressJpg from './img/ConcreteSectionGeometry.jpg';

const Fonctionnement = ({
	link
}) => {
	return(
		<div className="section"> 
			<Container>
				<Row>
					
					<Col lg={12}>
						<Row>
						<Fade left cascade>
								<Media className="app">
									<Media left href="#">
										<FormattedMessage id="section_alt">
											{
												alt =>  (
													<img
														className="icon" 
														src={ProcessSvg}
														alt={alt} 
													/>
												)
											}
										</FormattedMessage>
									</Media>
									<Media body>
										<Media heading>
											<h2 className="label">
                        Le Fonctionnement    
											</h2>
										</Media>
										<Label className="subTitle">
											Architecture
										</Label>
									</Media>
								</Media>
							</Fade>
						</Row>
						<Row>
							<Fade left>
								<p className="lead">
                  Une fois installé dans <a href="https://archicad.fr/" target="_blank" title="Archicad">Archicad</a> ou <a href="https://www.autodesk.fr/products/revit/overview" target="_blank" title="Revit">Revit</a>, et connecté à TriDyme, le plugin récupère les éléments porteurs (poutres, poteaux, murs, dalles,...) qui ont été définis dans le modèle architecural.
								</p>
                <p className="lead">
                  A partir de ces éléments, <strong>TriDyme crée un modèle structurel équivalent</strong> en y ajoutant les caractéristiques des matériaux et les charges.
								</p>
                <p className="lead">
                  Une fois cela fait, TriDyme lance l'analyse qui permet de calculer les efforts dans les éléments et de vérifier leur résistance.
								</p>
                <p className="lead">
                  Si tel n'est pas le cas <strong>TriDyme propose des alternatives en terme de design.</strong>
								</p>
                <p className="lead">
                  <strong>Exemple:</strong> Si le calcul détermine qu'un poteau en acier de diamètre 500mm, épaisseur 50mm et de nuance S235 a sa résistance qui est dépassée de 10%, TriDyme proposera alors des éléments optimisés pour reprendre ces efforts:
                </p>
							</Fade>
							<Fade left cascade>
								<ul className="lead">
									<li>
                    Poteau en acier de diamètre 500mm, épaisseur 50mm et de nuance S355
									</li>
									<li>
									  Poteau en acier de diamètre 550mm, épaisseur 50mm et de nuance S235
									</li>
									<li>
										...
									</li>
								</ul>
							</Fade>
						</Row>
						<Row>
              <Col lg={12}>
                <Fade left className>
                  <Button
                    href={link}
                    className="negativeButton"
                  >
                    Essayez
                  </Button>
                </Fade>
              </Col>
						</Row>
					</Col>
          {/* <Col lg={6}>
            <Fade right>
              <div className="imgContainer">
                <img className="imgContent" src={ConcreteSectionStressJpg} alt="Sections" /> 
              </div>
            </Fade>
					</Col> */}
				</Row>
			</Container>    
		</div>       
	);
};

export default Fonctionnement;
